import Vue from "vue"
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
const _ = require('lodash')

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default { 
  props: {
    width: {
      type: String,
      default: 'w-50 m-auto'
    },
    show: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: [Number, String],
      default: null
    },
    // type VAT ของบิลที่จะนำมัดจำไปหัก — lock ให้เลือกเฉพาะใบ AI type เดียวกัน
    billTaxType: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    Paginate
  },
  data() {
    return {
      busy: false,
      textInput: '',
      answer: 'ค้นหาจากเลขที่เอกสาร',
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      totalItem: 0,
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      fields: [
        {
          key: 'document_no',
          label: 'เลขที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-xs-1/2 py-1.5',
          sortable: true
        },
        {
          key: 'customer',
          label: 'ลูกค้า',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 text-xs-1/2 py-1.5',
          sortable: false,
        },
        {
          key: 'vat_type',
          label: 'VAT',
          thClass: 'font-weight-bold text-xs-1/2 text-center',
          tdClass: 'text-xs-1/2 py-1.5 text-center',
          sortable: false
        },
        {
          key: 'grand_total',
          label: 'ยอดสุทธิ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 text-xs-1/2 py-1.5',
          sortable: true
        },
        {
          key: 'action',
          label: '#',
          thClass: 'text-right font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 text-xs-1/2 py-1.5',
          class: 'text-right'
        }
      ],
      items: []
     }
  },
  computed: {
    rows() {
      return this.totalItem
    }
  },
  watch: {
    show: function (newValue, oldValue) {
      if (newValue) {
        this.onSearchHandler(this.currentPage) 
      }
    }
  },
  methods: {
    // vat_type ของใบ AI: 1 = แยก VAT, 2 = รวม VAT (ใบกำกับต้องมี VAT เสมอ)
    taxTypeLabel (t) {
      return Number(t) === 2 ? 'รวม VAT' : 'แยก VAT'
    },
    taxTypeClass (t) {
      return Number(t) === 2 ? 'badge-success' : 'badge-primary'
    },
    onClose () {
      this.$emit('onDepositTaxCloseHandler', {
        status: false
      })
    },
    onSelected(item) {
      this.$emit('onDepositTaxCloseHandler', {
        status: true,
        data: item
      })
    },
    async onSearchHandler (currentPage) {
      try {
        this.busy = true
        const page = currentPage || 1
        const customerFilter = this.customerId ? `&customer_id=${this.customerId}` : ''
        const vatFilter = this.billTaxType ? `&keyword_vat_type=${encodeURIComponent(this.billTaxType)}` : ''
        const url = `${Vue.prototype.$host}/api/v1/document/deposit-tax-invoice?page=${page}&per_page=8&keyword=${encodeURIComponent(this.textInput)}&exclude_cancelled=1${customerFilter}${vatFilter}`
        const result = await this.$axios.get(url)
        if (result) {
          this.currentData = result.data
          this.items = result.data.data
          this.totalItem = result.data.total || 0
          this.busy = false
        }
      } catch (error) {
        this.busy = false
      }
    }
  }
}
